import React, { useEffect } from "react";
import AboutTemplate from "../../Templetes/About/About.template";

const AboutPage = () => {
  useEffect(() => {
    document.title = "Code Challenge - About";
  }, []);
  return <AboutTemplate />;
};

export default AboutPage;
